import { render, staticRenderFns } from "./InlineTableView.vue?vue&type=template&id=054eb134&scoped=true&"
import script from "./InlineTableView.vue?vue&type=script&lang=js&"
export * from "./InlineTableView.vue?vue&type=script&lang=js&"
import style0 from "./InlineTableView.vue?vue&type=style&index=0&id=054eb134&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054eb134",
  null
  
)

export default component.exports